import { Component, OnInit } from '@angular/core';
import { ConstantsService } from "../services/constants.service";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-bookmarked-thanks',
  templateUrl: './bookmarked-thanks.component.html',
  styleUrls: ['./bookmarked-thanks.component.scss']
})
export class BookmarkedThanksComponent implements OnInit {

  constructor(public constants: ConstantsService,
    public dialogRef: MatDialogRef<any>,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
  }
  closeBookmarkAlert_2() {
    this.dialogRef.close()
  }
}
